module.exports = __webpack_public_path__ + "static/media/05.004333ba.png";